'use client';
import EditableComment from '@/client/components/EditableComment/EditableComment';
import { RefService } from '@/server';
import {
  IMagnoliaContext,
  MgnlContent,
  MgnlTemplateAnnotations,
  PageEditorBridge,
} from '@magnolia/frontend-helpers-base';
import { useEffect, useRef } from 'react';

const initialComponentConfig: {
  listeners: { [key: string]: (() => void)[] };
} = {
  listeners: {},
};

const EditablePageClient = ({
  content,
  magnoliaContext,
  templateAnnotations,
  useHistoryPushState,
}: {
  content: MgnlContent;
  magnoliaContext?: IMagnoliaContext;
  templateAnnotations?: MgnlTemplateAnnotations | null;
  useHistoryPushState?: boolean;
}) => {
  const comRef = useRef(initialComponentConfig);

  // Set template annotations in window for client rendering
  if (templateAnnotations) {
    RefService.setTemplateAnnotationsRef(templateAnnotations);
  }

  const getAnnotationString = (): string => {
    if (
      !!content &&
      templateAnnotations &&
      templateAnnotations[content['@path']]
    ) {
      return templateAnnotations[content['@path']];
    }
    return '';
  };

  useEffect(() => {
    if (magnoliaContext) {
      RefService.setMagnoliaContextRef(magnoliaContext);
    }
    if (magnoliaContext?.isMagnoliaEdit) {
      PageEditorBridge.initialVariantsHandler(
        comRef.current.listeners,
        useHistoryPushState
      );
      PageEditorBridge.init(comRef.current.listeners);
    }
  }, [magnoliaContext, useHistoryPushState]);

  return (
    <EditableComment
      alwaysRender={magnoliaContext?.isMagnolia}
      annotation={getAnnotationString()}
      shouldRefresh={true}
      shouldRunOnFrameReady={true}
    />
  );
};

export default EditablePageClient;
